import Typograf from '@a3/chameleon/src/components/basic/Typograf';
import cn from 'classnames';
import React from 'react';
import type { FC } from 'react';

import ContentContainer from 'components/basic/ContentContainer';
import { Body4, H2, Title2 } from 'components/basic/Typography';

import s from './WhyAreWe.module.scss';

const WhyAreWe: FC = () => {
  return (
    <Typograf>
      <div className={s.wrapper}>
        <ContentContainer grid>
          <H2 className={cn(s.head, 'g-col-m-12 g-col-xss-8')}>Почему мы:</H2>
          <img
            className={cn(
              s.developImage,
              'g-start-m-2 g-start-xss-1 g-col-m-4 g-col-s-3 g-col-xss-8',
            )}
            src="/componentsImages/MainPage/WhyAreWe/developMarket.jpg"
            alt="develop the market"
          />
          <Title2
            className={cn(
              s.developTitle,
              'g-start-m-8 g-start-s-5 g-start-xss-1 g-col-3xl-4 g-col-m-4 g-col-s-4 g-col-xss-8',
            )}
          >
            Более 15 лет развиваем рынок электронных платежей
          </Title2>
          <Body4
            className={cn(
              s.descriptionDevelop,
              'g-start-2xl-9 g-start-m-8 g-start-s-5 g-start-xss-1 g-col-2xl-3 g-col-m-4 g-col-s-4 g-col-xss-8',
            )}
          >
            {`Мы являемся участником инновационного проекта «Сколково» с 2020 года. В рамках финтех-хаба Сколково помогаем осуществлять исследовательскую деятельность, которая способствует развитию цифровой зрелости ключевых отраслей экономики России. 

Входим в топ-100 финтех-компаний по версии Smart Ranking. 

Наши продукты получают признание финтех-сообщества и побеждают на отраслевых премиях.

Например, продукт А3.Household признан лучшим в номинации финтех-прорыв FinAward 2024 и победителем в номинации лучшее финтех-партнерство премии FinNext 2024.`}
          </Body4>
          <Title2
            className={cn(
              s.skTitle,
              'g-start-m-2 g-start-xss-1 g-col-3xl-5 g-col-l-3 g-col-m-4 g-col-s-3 g-col-xss-8',
            )}
          >
            Используем последние технологии
          </Title2>
          <Body4
            className={cn(
              s.skDescription,
              'g-start-2xl-3 g-start-m-2 g-start-xss-1 g-col-2xl-3 g-col-m-4 g-col-s-3 g-col-xss-8',
            )}
          >
            Мы используем актуальный стек технологий, который позволяет компании
            и сотрудникам развиваться в соответствии с трендами и запросами
            индустрии.
          </Body4>
          <Title2
            className={cn(
              s.productsTitle,
              'g-start-m-2 g-start-xss-1 g-col-3xl-5 g-col-l-3 g-col-m-4 g-col-s-3 g-col-xss-8',
            )}
          >
            Придумываем и развиваем новые инновационные продукты для отрасли
          </Title2>
          <Body4
            className={cn(
              s.productsDescription,
              'g-start-2xl-3 g-start-m-2 g-start-xss-1 g-col-2xl-3 g-col-m-4 g-col-s-3 g-col-xss-8',
            )}
          >
            Мы собрали в своей команде лучших представителей финтеха, чтобы
            каждый год выпускать сотни улучшений и функций, которые помогут вам
            опережать изменения в отрасли.
          </Body4>
          <img
            className={cn(
              s.productsImg,
              'g-start-m-7 g-start-s-5 g-start-xss-1 g-col-m-5 g-col-s-4 g-col-xss-8',
            )}
            src="/componentsImages/MainPage/WhyAreWe/newProducts.jpg"
            alt="new products photo"
          />
          <img
            className={cn(
              s.serviceImg,
              'g-start-m-2 g-start-xss-1 g-col-m-5 g-col-s-3 g-col-xss-8',
            )}
            src="/componentsImages/MainPage/WhyAreWe/makeService.jpg"
            alt="make service image"
          />
          <Title2
            className={cn(
              s.serviceTitle,
              'g-start-m-8 g-start-s-5 g-start-xss-1 g-col-s-4 g-col-xss-8',
            )}
          >
            Оказываем сервис с индивидуальным подходом
          </Title2>
          <Body4
            className={cn(
              s.serviceDescription,
              'g-start-2xl-9 g-start-m-8 g-start-s-5 g-start-xss-1 g-col-xl-3 g-col-m-4 g-col-s-4 g-col-xss-8',
            )}
          >
            Для каждого контрагента мы предоставляем личного менеджера и делаем
            конструирование процесса платежа с учетом ваших потребностей и
            специфики работы каждого партнера.
          </Body4>
        </ContentContainer>
      </div>
    </Typograf>
  );
};

export default WhyAreWe;
